import {gql} from '@apollo/client';

// blog

export const onSubscribeMutation = gql`
mutation Subscribe($email: Email!, $path: String!) {
	contact {
		capture(reason: NEWSLETTER, email: $email, path: $path)
	}
}`;

/// sign-in

export const logInMutation = gql`
mutation ($email: String!, $password: String!) {
    account {
        logIn(email: $email, password: $password) {
            error
            token
        }
    }
}`;

/// waitList

export const contactQuery = gql`
mutation addContact(
	$firstName: String!,
	$lastName: String!,
	$email: Email!,
	$zipCode: String!,
	$path: String!,
) {
	contact {
		capture(
			reason: INTEREST_LIST,
			path: $path,
			email: $email,
			firstName: $firstName,
			lastName: $lastName,
			zipCode: $zipCode,
		)
	}
}`;
